"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeDisplay = exports.TimeDisplayDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var fecha_1 = __importDefault(require("fecha"));
exports.TimeDisplayDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 600;\n    background: ", ";\n    border: 3px solid ", ";\n    border-radius: 3px;\n    padding: 0px ", ";\n  "], ["\n    font-size: ", ";\n    font-weight: 600;\n    background: ", ";\n    border: 3px solid ", ";\n    border-radius: 3px;\n    padding: 0px ", ";\n  "])), theme_1.theme.FONT_SIZE(15), theme_1.theme.DARKEN('primary', 0.1), theme_1.theme.DARKEN('primary', 0.1), theme_1.theme.UNIT(2))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    justify-content: center;\n\n  "], ["\n    color: ", ";\n    display: flex;\n    flex-direction: row;\n    align-items: baseline;\n    justify-content: center;\n\n  "])), theme_1.theme.COLOR('light'))
});
var BlockStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme_1.theme.UNIT(1), theme_1.theme.UNIT(0))
});
var HourStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), BlockStyles)
});
var MinuteStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), BlockStyles)
});
var SuffixStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    text-transform: lowercase;\n    font-size: 0.9em;\n    font-weight: 400;\n    padding: ", ";\n    padding-right: 0;\n  "], ["\n    text-transform: lowercase;\n    font-size: 0.9em;\n    font-weight: 400;\n    padding: ", ";\n    padding-right: 0;\n  "])), theme_1.theme.UNIT(1))
});
var SeparatorStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: block;\n    font-size: 0.8em;\n    align-self: center; \n    padding: ", ";\n  "], ["\n    display: block;\n    font-size: 0.8em;\n    align-self: center; \n    padding: ", ";\n  "])), theme_1.theme.UNIT(0.5))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Hour: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), HourStyles),
  Separator: styled_components_1.default.span(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), SeparatorStyles),
  Minute: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), MinuteStyles),
  Suffix: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), SuffixStyles)
};
var TimeDisplay = function (props) {
  var className = props.className,
    date = props.date;
  if (!date) {
    return null;
  }
  var parsed = fecha_1.default.parse(date, 'YYYY-MM-DDTHH:mm');
  if (!parsed) {
    return null;
  }
  var hour = fecha_1.default.format(parsed, 'h');
  var minute = fecha_1.default.format(parsed, 'mm');
  var suffix = fecha_1.default.format(parsed, 'a');
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Body, null, react_1.default.createElement(My.Hour, null, hour), react_1.default.createElement(My.Separator, null, ":"), react_1.default.createElement(My.Minute, null, minute), react_1.default.createElement(My.Suffix, null, suffix)));
};
exports.TimeDisplay = TimeDisplay;
exports.TimeDisplay.defaultProps = exports.TimeDisplayDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;